import React from 'react'
import PropTypes from 'prop-types'
import DropDownFilterBase from '../DropDownFilterBase/DropDownFilterBase'
import style from './SelectFilter.less'
import ChevronDown from 'styles/icons/chevron_down.svg'
import classNames from 'classnames'
import MediaQuery from 'react-responsive'
import responsive from 'common/utils/responsive'

class SelectFilter extends DropDownFilterBase {

  constructor(props) {
    super(props)
    if (this.props.data.length > 0) {
      this.state = {
        label: this.props.data[this.props.selected].label,
        data: this.props.data[this.props.selected].data,
      }
    }
  }

  createListItem = (item, index) => (
    <li
      key={index}
      className={(item.data == this.state.data) ? style.active : null}
      onClick={() => this.selectClick(item)}
      data-test={item.data}
    >
      {this.createListItemContent(item)}
    </li>
  )

  createListItemContent = (item) => item.label

  createSelectItem = (item, index) => (
    <option
      key={index}
      onClick={() => this.selectClick(item)}
      selected={(item.data == this.state.data)}
      value={item.data}
    >
      {item.label}
    </option>
  )

  selectClick = (activeItem) => {
    this.props.onChange(activeItem.data)
    this.setState({
      label: activeItem.label,
      data: activeItem.data,
    })
    this.closeMenu(null)
  }

  onSelectChange = (event) => {
    const value = this.props.data.filter(
      (item) => item.data == event.target.value)

    this.selectClick(value[0])
  }

  getStyle = () => {
    switch (this.props.style) {
      case 'inlineButton':
        return style.inlineButton
      case 'dark':
        return style.dark
      default:
        return style.main
    }
  }

  createList = () => {
    const { data } = this.props
    return (
      <ul
        className={style.dropdown}
        onClick={this.listClick}
        data-test="selectFilterDropdownDesktop"
      >
        {data &&
          data.map(this.createListItem)
        }
      </ul>
    )
  }

  createMobileSelect = () => {
    const { data } = this.props
    return (
      <select
        name="text"
        onChange={this.onSelectChange}
        value={this.state.data}
        data-test="selectFilterMobile"
      >
        {data &&
          data.map(this.createSelectItem)
        }
      </select>
    )
  }

  getTriggerStyle = () => style.trigger;

  render() {
    const { align, iconSVG, label } = this.props
    const alignStyle = (align == 'right') ? style.alightRight : {}
    const className = classNames(this.getStyle(), alignStyle)
    return (
      <div className={className}>

        <MediaQuery maxWidth={responsive.MEDIA_QUERY_TABLET}>
          {this.createMobileSelect()}
        </MediaQuery>

        <MediaQuery minWidth={responsive.MEDIA_QUERY_TABLET}>
          <div
            className={this.getTriggerStyle()}
            onClick={this.toggleClick}
            data-test="selectTrigger"
          >
            {label &&
              <div className={style.label}>
                {label}
              </div>
            }
            {iconSVG &&
              <svg viewBox={iconSVG.viewBox} className={style.icon}>
                <use xlinkHref={`#${iconSVG.id}`} />
              </svg>
            }
            <span className={style.content}>{this.state.label}</span>
            <svg viewBox={ChevronDown.viewBox} className={style.downArrow}>
              <use xlinkHref={`#${ChevronDown.id}`} />
            </svg>
          </div>
        </MediaQuery>

        {this.state.open &&
          this.createList()
        }
      </div>
    )
  }
}

SelectFilter.defaultProps = {
  selected: 0,
}

SelectFilter.propTypes = {
  data: PropTypes.array.isRequired,
  onChange: PropTypes.func,
  align: PropTypes.string,
  iconSVG: PropTypes.object,
  selected: PropTypes.number,
  label: PropTypes.string,
  style: PropTypes.string,
}

export default SelectFilter
